import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Per-route side effect: scroll to top on navigation.
 * (Entrance reveals are handled in pure CSS — see `.reveal` in index.css —
 * so there is no JS DOM mutation to conflict with hydration.)
 */
export default function useSiteEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
}
